import React from "react";
import Header from "../../components/Header/Header";
import "./TermsOfService.css";

function TermsOfService() {
  return (
    <main className="TermsOfService">
      <Header
        title="Terms of Service – Guidelines for Using Our Platform"
        subtitle="Review the terms and conditions that govern your use of our website and services. By accessing our platform, you agree to these terms."
      />
      <h3>Introduction</h3>
      <p>
        These Terms of Service (“Terms”) outline the rules and regulations for
        using our website, applications, and services. By accessing or using our
        platform, you accept these Terms. If you do not agree, please
        discontinue use.
      </p>
      <h3>Eligibility</h3>
      <p>To use our services, you must:</p>
      <ul>
        <li>
          <p>
            Be at least 18 years old (or have parental/guardian consent if
            younger).
          </p>
        </li>
        <li>
          <p>
            Provide accurate, current, and complete information when creating an
            account.
          </p>
        </li>
      </ul>
      <h3>User Responsibilities</h3>
      <p>When using our services, you agree to:</p>
      <ul>
        <li>
          <p>Use the platform for lawful purposes only.</p>
        </li>
        <li>
          <p>Not engage in fraudulent, abusive, or harmful activity.</p>
        </li>
        <li>
          <p>Maintain the confidentiality of your account credentials.</p>
        </li>
        <li>
          <p>Be responsible for any activity under your account.</p>
        </li>
      </ul>
      <h3>Intellectual Property</h3>
      <p>
        All content, including text, images, logos, and designs, are owned by us
        or our licensors. You may not copy, distribute, or reproduce them
        without prior written consent.
      </p>
      <h3>Purchases and Payments</h3>
      <ul>
        <li>
          <p>Prices are displayed in [currency].</p>
        </li>
        <li>
          <p>Payments must be made through authorized payment methods.</p>
        </li>
        <li>
          <p>Refunds are subject to our Refund Policy (if applicable).</p>
        </li>
      </ul>
      <h3>Limitation of Liability</h3>
      <p>
        We strive to provide reliable services but cannot guarantee
        uninterrupted or error-free operation. To the extent permitted by law,
        we are not liable for any damages resulting from your use of our
        services.
      </p>
      <h3>Termination</h3>
      <p>
        We reserve the right to suspend or terminate your account if you violate
        these Terms or engage in harmful activities.
      </p>
      <h3>Governing Law</h3>
      <p>
        These Terms shall be governed by and interpreted in accordance with the
        laws of [Your Country/Region].
      </p>
      <h3>Changes to Terms</h3>
      <p>
        We may update these Terms from time to time. Continued use of the
        platform after updates means you accept the revised Terms.
      </p>
    </main>
  );
}

export default TermsOfService;
